export default "__VITE_ASSET__DxdzNiiC__"